'use strict';

var processInclude = require('./util');

processInclude(require('./components/footer'));
